import { useLocation, useNavigate } from 'react-router-dom'

import {
  type EventTab,
  EventTabs,
} from '~/features/event-info/types/event-info'

const useEventTab = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const pathToTabMap: { [key: string]: EventTab } = {
    '/event-info/introduction': EventTabs.INTRODUCTION,
    '/event-info/timetable': EventTabs.TIMETABLE,
    '/event-info/layout': EventTabs.LAYOUT,
    '/event-info/circle-list': EventTabs.CIRCLE_LIST,
  }

  const getTabFromPathname = (pathname: string): EventTab => {
    return pathToTabMap[pathname] || EventTabs.INTRODUCTION
  }

  const getPathFromTab = (tab: EventTab): string => {
    const entry = Object.entries(pathToTabMap).find(
      ([_, value]) => value === tab,
    )

    return entry ? entry[0] : '/event-info/introduction'
  }

  const eventTab = getTabFromPathname(location.pathname)

  const setEventTab = (tab: EventTab) => {
    const path = getPathFromTab(tab)
    navigate(path)
  }

  return {
    eventTab,
    setEventTab,
  }
}

export default useEventTab
